export default "__VITE_ASSET__D2m7f1uo__"